import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table } from '@src/shared/ui/components/TableStatic';
import { merge } from 'lodash';
import React from 'react';

import configuration from './includes/configuration.json';

/**
 * DataTable
 *
 * a data table is a structured arrangement of information into rows and columns for organizing and presenting data in
 * a tabular format.
 *
 * @param data
 * @param tableConfiguration
 * @returns {Element}
 * @constructor
 */
export function DataTable({ data, tableConfiguration = {} }) {
  return (
    <ErrorHandler location="src/shared/ui/components/Chart/components/DataTable/DataTable.jsx">
      <Table
        {...{
          columns: tableConfiguration?.initialColumns,
          configuration: merge({}, configuration, tableConfiguration),
          rows: data,
        }}
      />
    </ErrorHandler>
  );
}
